/* eslint-disable */
import { useContext, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import P, { shape } from 'prop-types';
import ConfirmationDialog from '../ConfirmationDialog';
import { MainContext } from '../../context/ApiContext';
import UserForm from '../UserForm';
import { MaskedTextField } from '../FormFields';
import { Duration, DateTime } from 'luxon';

const SummaryReport = ({ listItem, title }) => {
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [user, setUser] = useState(null);
  const [id, setId] = useState('');
  const [totals, setTotals] = useState({
    inviter_all_leads: 0,
    captures_on_time: 0,
    attendances_on_time: 0,
    had_contact: 0,
    quoted: 0,
    backup_car: 0,
    pague_menos: 0,
    sold: 0,
    conversion: 0,
  });
  const [dialog, setDialog] = useState({
    msg: '',
    title: '',
  });

  return (
    <>
      <ConfirmationDialog
        open={openConfirm}
        setOpen={setOpenConfirm}
        msg={dialog.msg.length > 0 ? dialog.msg : 'Dialog'}
        title={dialog.title.length > 0 ? dialog.title : 'Dialog'}
      />
      <UserForm open={open} setOpen={setOpen} title={title} user={user} />
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Indicador</TableCell>
              <TableCell>Indicados no Período</TableCell>
              <TableCell>Indicados Fora do Prazo</TableCell>

              <TableCell>Consultor de F&I confirmou que cliente tem interesse</TableCell>
              <TableCell>Cliente ainda não respondeu se foi informado da Pessego</TableCell>
              <TableCell>Cliente disse que não passou pelo F&I</TableCell>
              <TableCell>Cliente negou que foi informado pelo F&i</TableCell>
              <TableCell>Cliente confirmou que foi informado da Pessego</TableCell>

              <TableCell>Vendido</TableCell>
              <TableCell align="center">Conversão Vendas</TableCell>
              <TableCell>Ranking</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listItem !== null &&
              listItem?.map((item) => (
                <TableRow key={item.inviter_id}>
                  <TableCell>{item.inviter_name || '-'}</TableCell>
                  <TableCell>{item.inviter_all_leads}</TableCell>

                  <TableCell>{item.indications_not_on_time || '-'}</TableCell>

                  <TableCell>{item.fi_referral_accepted}</TableCell>
                  <TableCell>{item.crm_contact_no_response}</TableCell>
                  <TableCell>{item.crm_contact_not_fi}</TableCell>
                  <TableCell>{item.crm_contact_denied}</TableCell>
                  <TableCell>{item.crm_contact_accepted}</TableCell>

                  <TableCell>{item.sold || '-'}</TableCell>
                  <TableCell align="center">{item.conversion} %</TableCell>
                  <TableCell>* {item.ranking} * </TableCell>
                </TableRow>
              ))}
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}>Total</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current.inviter_all_leads);
                }, 0)}
              </TableCell>

              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current.indications_not_on_time);
                }, 0)}
              </TableCell>

              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current.fi_referral_accepted);
                }, 0)}
              </TableCell>

              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current.crm_contact_no_response);
                }, 0)}
              </TableCell>

              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current.crm_contact_not_fi);
                }, 0)}
              </TableCell>

              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current.crm_contact_denied);
                }, 0)}
              </TableCell>

              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current.crm_contact_accepted);
                }, 0)}
              </TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current.sold);
                }, 0)}
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

SummaryReport.propTypes = {
  listItem: P.arrayOf(
    shape({
      id: P.number,
      name: P.string,
    })
  ),
  title: P.string.isRequired,
};

SummaryReport.defaultProps = {
  listItem: null,
};

export default SummaryReport;
